import { render, staticRenderFns } from "./schoolProject.vue?vue&type=template&id=248735f8&scoped=true"
import script from "./schoolProject.vue?vue&type=script&lang=js"
export * from "./schoolProject.vue?vue&type=script&lang=js"
import style0 from "./schoolProject.vue?vue&type=style&index=0&id=248735f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248735f8",
  null
  
)

export default component.exports